import Cores from "./components/Cores"

export const AboutUs = () => {

    const AboutUsBottom = () => {
        return (
            <div className="w-full mt-0 relative lg:h-[30rem] flex flex-row items-center justify-center gap-4">
                <div className="w-[18rem] lg:w-[20rem] h-[17rem] sm:h-[30rem] max-w-sm lg:absolute lg:top-0 lg:left-0 flex justify-center items-center border-2 border-white rounded-full">
                    <img
                        className="w-full h-full object-cover object-[80%_0%] rounded-full"
                        src="/assets/about-us/bottoms/first-young-fitness.jpg"
                        alt="A bodybuilder lifting weights"
                    />
                </div>

                <div className="flex flex-col gap-4 lg:mt-0 lg:ml-auto lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:right-0">
                    <div className="w-[7.8rem] h-[7.8rem] sm:w-[14.5rem] sm:h-[14.5rem] overflow-hidden rounded-full border-2 border-white flex justify-center items-center">
                        <img
                            className="w-full h-full object-cover object-center"
                            src="/assets/about-us/bottoms/second-young-woman.jpg"
                            alt="A person doing crunches"
                        />
                    </div>
                    <div className="w-[7.8rem] h-[7.8rem] sm:w-[14.5rem] sm:h-[14.5rem] overflow-hidden rounded-bl-full rounded-br-full border-2 border-white flex justify-center items-center">
                        <img
                            className="w-full h-full object-cover object-center"
                            src="/assets/about-us/bottoms/third-sports-man.jpg"
                            alt="A person lifting weights on a bench press"
                        />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-col">

            {/* <!-- Hero Title --> */}
            <section className="w-full bg-gradient-radial lg:pt-20 pt-20 pb-12 lg:py-28">
                <div className="w-full lg:w-full flex flex-col items-center py-12">
                    <img className="md:w-[25rem] w-[15rem] h-auto" src="/assets/FWPI-logo.png" alt="FWPI Logo About Us" />
                </div>
                <div className="w-full lg:w-full flex flex-col items-center">
                    <h2 className="text-2xl sm:text-2xl lg:text-4xl font-bold font-urbanist text-white text-center sm:text-center">
                        Empowering Professionals with Global Standards & Recognition
                    </h2>
                </div>
            </section>

            {/* <!-- Who We Are Section --> */}
            <section className="w-full bg-gradient-radial pb-12 lg:pb-24">
                <div className="container mx-auto px-4 lg:px-15">
                    {/* <!-- Combined Card --> */}
                    <div className="relative bg-gradient-radial w-full p-6 md:p-6 md:rounded-tl-[1rem] md:rounded-tr-[11rem] md:rounded-bl-[5rem] md:rounded-br-[11rem] rounded-3xl rounded-tl-md border-2 border-white flex flex-col md:flex-row items-start gap-8">
                        {/* <!-- Text Container --> */}
                        <div className="relative w-full md:w-1/2 font-poppins">
                            <div className="w-44 text-center bg-red-50 rounded-tl-[10px] rounded-tr-[50px] rounded-bl-[40px] rounded-br-[50px] outline outline-1 outline-offset-[-0.50px] outline-white p-2 md:p-1.5 lg:p-2">
                                <span className="text-black text-xl-responsive md:text-lg lg:text-xl-responsive font-medium font-Poppins">Who We Are</span>
                            </div>

                            <div className="md:hidden w-full py-5 md:w-1/2">
                                <img className="w-full h-full object-cover rounded-b-lg rounded-t-3xl border-2 border-white" src="/assets/about-us/first-sport-traininh.jpg" alt="Man working out." />
                            </div>

                            <div className="md:mt-5 lg:mt-12">
                                <p className="text-white text-sm md:text-[0.75rem] lg:text-base font-normal">
                                    <span className="font-bold">At FWPI</span>, we are committed to setting benchmarks in professional conduct, education, accreditation, and recognition. Whether you're a personal trainer, wellness coach, therapist, mentor, or an educator FWPI offers the credibility, support, and community you need to grow and make a meaningful impact. FWPI is a nationally registered organization under the Ministry of MSME, Govt. of India, proudly ISO 9001:2015 Certified and Internationally Accredited by IAOTH, UK.
                                </p>
                            </div>
                        </div>
                        {/* <!-- Image --> */}
                        <div className="hidden md:flex w-full md:w-1/2">
                            <img className="w-full h-auto object-cover rounded-tl-lg rounded-tr-[10rem] rounded-bl-[10rem] rounded-br-[10rem] outline outline-2 outline-offset-[-1px] outline-white" src="/assets/about-us/first-sport-traininh.jpg" alt="Man working out." />
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- We Function as Both Section --> */}
            <section className="w-full bg-gradient-radial pb-12 lg:pb-24">
                <div className="container mx-auto px-4 lg:px-15">
                    {/* <!-- Combined Card --> */}
                    <div className="relative bg-gradient-radial w-full p-6 md:p-6 lg:rounded-tl-[11rem] lg:rounded-tr-[1rem] lg:rounded-bl-[11rem] lg:rounded-br-[5rem] rounded-3xl rounded-tr-md border-2 border-white flex flex-col md:flex-row items-start gap-8">
                        {/* <!-- Image --> */}
                        <div className="hidden lg:flex w-full md:w-1/2">
                            <img className="w-full h-auto object-cover rounded-tl-[10rem] rounded-tr-lg rounded-bl-[10rem] rounded-br-[10rem] border-2 border-white" src="/assets/about-us/second-fitness-coach.jpg" alt="second fitness coach" />
                        </div>
                        {/* <!-- Text Container --> */}
                        <div className="relative w-full lg:w-1/2">
                            <div className="flex justify-end lg:justify-start">
                                <div className="w-64 bg-white  lg:rounded-tl-[10px] rounded-tl-[50px] lg:rounded-tr-[50px] rounded-tr-[10px] lg:rounded-bl-[40px] rounded-bl-[50px] rounded-br-[40px] border border-white flex items-center justify-center p-2">
                                    <span className="text-black text-xl-responsive font-medium font-poppins">We function as both</span>
                                </div>
                            </div>

                            <div className="lg:hidden xl:hidden w-full py-5 lg:w-1/2">
                                <img className="w-full h-full object-cover rounded-b-lg rounded-t-3xl border-2 border-white" src="/assets/about-us/second-fitness-coach.jpg" alt="second fitness coach" />
                            </div>

                            <div className="md:mt-12">
                                <div className="flex flex-col items-center gap-6 pl-7">
                                    <ul className="list-disc list-outside font-poppins space-y-4 text-left">
                                        <li className="text-neutral-200 sm:text-lg text-base">
                                            A Professional Membership Body for fitness, nutrition, therapy, and wellness experts.
                                        </li>
                                        <li className="text-neutral-200 sm:text-lg text-base">
                                            An Independent Accreditation Authority for institutions, gym & studio facilities.
                                        </li>
                                    </ul>
                                </div>

                                <p className="text-white text-base font-medium mt-5">
                                    FWPI represents the voice of ethical, skilled, and responsible wellness professionals across India. Our goal is to ensure that every professional serving society in health, nutrition, and fitness is credible, competent, and supported with the right standards, recognition, and resources.
                                </p>
                            </div>
                        </div>
                    </div>
                </div >
            </section >

            {/* <!-- Core Values Section --> */}
            <Cores />

            {/* <!-- Mission and Vision Section --> */}
            {/* <section className="container mx-auto px-4 py-8 flex flex-col lg:flex-row items-center justify-between gap-12" > */}

            <section className="w-full bg-gradient-radial pb-12 lg:pb-24">
                <div className="container mx-auto px-4 lg:px-15">
                    {/* <!-- Mission & Vision Cards --> */}
                    <div className="flex flex-col lg:flex-row items-center justify-between gap-12" >
                        <div className="flex flex-col gap-8 w-full lg:w-1/2" >
                            <div className="bg-gradient-radial w-full p-6 md:p-6 lg:rounded-tl-[1rem] lg:rounded-tr-[11rem] lg:rounded-bl-[5rem] lg:rounded-br-[11rem] rounded-3xl rounded-tl-md border-2 border-white flex flex-col md:flex-col items-start gap-8  font-poppins">
                                {/* <!-- Text Container --> */}
                                <div className="w-44 text-center bg-red-50 rounded-tl-[10px] rounded-tr-[50px] rounded-bl-[40px] rounded-br-[50px] outline outline-1 outline-offset-[-0.50px] outline-white p-2">
                                    <span className="text-black text-xl-responsive font-medium font-Poppins">Our Mission</span>
                                </div>
                                <div className="">
                                    <p className="text-white text-base font-normal">
                                        To unite India’s fitness and wellness professionals, gyms, studios, and academies into one credible national platform—raising standards, building trust, and empowering the industry to create a healthier and stronger India.
                                    </p>
                                </div>
                            </div>

                            <div className="w-full lg:hidden">
                                <AboutUsBottom />
                            </div>

                            <div className="bg-gradient-radial w-full p-6 md:p-6 lg:rounded-tl-[11rem] lg:rounded-tr-[1rem] lg:rounded-bl-[11rem] lg:rounded-br-[5rem] rounded-3xl rounded-tr-md border-2 border-white flex flex-col md:flex-col items-start gap-8">
                                <div className="w-full flex flex-col items-end justify-end">
                                    <div className="w-44 bg-white rounded-tl-[50px] rounded-tr-[10px] rounded-bl-[50px] rounded-br-[50px] border border-white flex items-center justify-center p-2">
                                        <span className="text-black text-xl-responsive font-medium font-poppins">Our Vision</span>
                                    </div>
                                </div>
                                <div className="md:mb-5 pl-5">
                                    <p className="text-white text-base font-medium">
                                        By 2035, FWPI aims to certify and recognize 2,00,000 ethical and qualified professionals, institutions, and facilities building India’s largest and most credible fitness & wellness network.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* <!-- Image Cluster --> */}
                        <div className="hidden lg:w-1/2 mt-12 lg:mt-0 lg:flex">
                            <AboutUsBottom />
                        </div>

                    </div>
                </div>
            </section>
        </div >
    )
}